import { createAction } from "redux-act";

export const OpenEditFilterModalAction = createAction("Edit Conditions - Open Modal");
export const CloseEditFilterModalAction = createAction("Edit Conditions - Close Modal");
